export default __webpack_public_path__ + "static/media/midasi_point_zh_cn_pc@2x.96af9ae2.png";